<style lang="scss">
@import "./assets/css/pure-min.css";
@import "./assets/css/grids-responsive-min";
</style>

<template>
  <div id="app">
    <div style="width: 100%; text-align: center">
      <router-link to='/'><img style="margin: auto; max-width: 80%; padding-left: 32px; padding-right: 32px;" src="~@/assets/3bmlogo.jpg">
      </router-link>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {}
  }
}
</script>

<style>
@font-face {
  font-family: "Roboto";
  src: url('./assets/fonts/roboto.woff2') format('woff2');
  font-weight: normal;
  font-style: normal;
}
#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue